import React, { useContext } from 'react';

import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 6rem;
`;

const NoAttendanceView: React.FC = () => {
    const { t } = useContext(AttendanceContext);

    return (
        <Container>
            <span id='attendance-no-data'>{t('no-attendance')}</span>
        </Container>
    );
};

export default NoAttendanceView;
